import { getField, updateField } from "vuex-map-fields";
import API from "@/api";

const initialState = () => ({
  savedImgLogoNavbar: null,
  savedImgLogoDarkNavbar: null,
  savedImgBackgroundHome: null,
  savedImgHeading: null,
  uploadImgBackground: null,
  uploadImgLogo: null,
  APP_LOGO_MAX_HEIGHT: 60,
  APP_LOGO_MAX_WIDTH: 250,
  BACKGROUND_MAX_HEIGHT: 500,
  BACKGROUND_MAX_WIDTH: 700,
  logoLoaded: false,
  backgroundLoaded: false,
  headingLoaded: false,
});

export const state = initialState();

export const getters = {
  getField,
  getImgLogo(state) {
    return state.savedImgLogoNavbar;
  },
};

export const actions = {
  loadImages({ dispatch }) {
    dispatch("getImage", "background");

    dispatch("getImage", "logo");

    dispatch("getImage", "heading");
  },
  async getImage({ state, commit, dispatch }, imgType) {
    commit("updateField", { path: `${imgType}Loaded`, value: false });
    await API.axios
      .get(`/bff/api/v1/static/assets/${imgType}.png`, { responseType: "blob" })
      .then((res) => {
        if (res.status === 200) {
          let fileReader = new FileReader();
          fileReader.onload = (event) => {
            switch (imgType) {
              case "logo":
                if (state.savedImgLogoNavbar !== event.target.result) {
                  commit("updateField", {
                    path: "savedImgLogoNavbar",
                    value: event.target.result,
                  });
                }
                break;
              case "background":
                if (state.savedImgBackgroundHome !== event.target.result) {
                  commit("updateField", {
                    path: "savedImgBackgroundHome",
                    value: event.target.result,
                  });
                }
                break;
              case "heading":
                if (state.savedImgHeading !== event.target.result) {
                  commit("updateField", {
                    path: "savedImgHeading",
                    value: event.target.result,
                  });
                }
                break;
            }
            commit("updateField", { path: `${imgType}Loaded`, value: true });
          };
          fileReader.readAsDataURL(res.data);
        }
      })
      .catch((error) => {
        if (error) console.log("Error assets", error);
        dispatch("common/raiseErrorMessage", "Algo deu errado! Erro 0x02", {
          root: true,
        });
      });
    await dispatch("getDarkModeImage");
  },

  async getDarkModeImage({ state, commit }) {
    await API.axios
      .get("/bff/api/v1/static/assets/logo-dark.png", {
        responseType: "blob",
      })
      .then((response) => {
        if (response.status !== 200) return;
        let fileReader = new FileReader();
        fileReader.onload = (event) => {
          if (state.savedImgLogoDarkNavbar !== event.target.result) {
            commit("updateField", {
              path: "savedImgLogoDarkNavbar",
              value: event.target.result,
            });
          }
        };
        fileReader.readAsDataURL(response.data);
      });
  },

  async importImage({ commit, dispatch, state }, { file, type }) {
    const formData = new FormData();
    formData.append("file", file);
    const config = {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    };
    const response = await API.axios.post(
      `/bff/api/v1/assets/import?img=${type}`,
      formData,
      config
    );

    return response;
  },
  resetState({ commit }) {
    commit("resetState");
  },
};

export const mutations = {
  updateField,
  resetState(state) {
    Object.assign(state, initialState());
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
